import { custFormatDate } from './data-jsFn'
import Decimal from 'decimal.js'

type WithdrawalDrug = { id: string | number; drugName: string; quantity: string | number; unit: string }
type WithdrawalPrescription = { id: string | number; name: string; prescriptionType: number; chineseMedicineType: number; quantity: number; weight: string | number; drugList: WithdrawalDrug[] }

// 只读取 withdrawal-drug-receipt 的已汇总退药处方；不再查询或拼接操作记录。
export function renderDrugReturnReceipt(patient: any, config: any, printedAt = new Date()) {
  const fontSize = Math.max(Number(config.fontSize) || 14, 14)
  const lineSpacing = Number(config.lineSpacing) || 4
  const escapeHtml = (value: unknown) => String(value ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;')
  const row = (label: string, value: unknown) => value == null || value === '' ? '' : `<div>${label}：${escapeHtml(value)}</div>`
  const age = [patient.ageYear != null ? `${patient.ageYear}岁` : '', patient.ageMonth ? `${patient.ageMonth}月` : '', patient.ageDay ? `${patient.ageDay}天` : ''].filter(Boolean).join(' ')
  const sex = patient.sex === 1 ? '男' : patient.sex === 2 ? '女' : ''
  const phone = config.phoneDisplay === 3 ? '' : config.phoneDisplay === 1
    ? patient.mobile : String(patient.mobile ?? '').replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  if (!Array.isArray(patient.prescriptionList)) throw new Error('退药打印数据缺少 prescriptionList')
  const sections = patient.prescriptionList.map((prescription: WithdrawalPrescription) => {
    if (!Array.isArray(prescription.drugList)) throw new Error('退药处方缺少 drugList')
    const isChinese = prescription.prescriptionType === 1
    const doses = isChinese && prescription.quantity != null && new Decimal(prescription.quantity).gt(0)
      ? new Decimal(prescription.quantity) : undefined
    const totalWeight = isChinese && prescription.weight != null ? new Decimal(prescription.weight) : undefined
    const singleWeight = doses && totalWeight ? totalWeight.div(doses) : undefined
    const medicineType = prescription.chineseMedicineType === 1 ? '饮片' : prescription.chineseMedicineType === 2 ? '颗粒' : ''
    const drugs = prescription.drugList.map(drug => {
      const quantity = doses ? new Decimal(drug.quantity).div(doses) : drug.quantity
      return `<div style="display:flex;justify-content:space-between;gap:4px;min-width:0;">
        <span>${escapeHtml(drug.drugName)}</span><span style="white-space:nowrap;">${isChinese && !doses ? '已退' : ''}${escapeHtml(quantity)}${escapeHtml(drug.unit)}</span>
      </div>`
    }).join('')
    const summary = isChinese ? `${doses ? `共 ${doses.toString()}剂 ` : ''}（${medicineType}${prescription.drugList.length}味${singleWeight ? ` 单剂${singleWeight.toString()}g` : ''}${totalWeight ? ` 总重${totalWeight.toString()}g` : ''}）` : ''
    return `<section class="drug-return-prescription" style="border-top:1px dashed #000;padding:${lineSpacing}px 0;break-inside:avoid;">
      ${prescription.name ? `<div style="font-weight:bold;">${escapeHtml(prescription.name)}</div>` : ''}
      <div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));column-gap:14px;">${drugs}</div>
      ${summary ? `<div>${escapeHtml(summary)}</div>` : ''}
    </section>`
  }).join('')
  return `<div style="font-size:${fontSize}px;line-height:${fontSize + lineSpacing}px;font-family:Arial,'Microsoft YaHei',sans-serif;">
    ${config.settingName ? `<div style="text-align:center;font-weight:bold;font-size:${fontSize + 4}px;line-height:${fontSize + lineSpacing + 4}px;">${escapeHtml(config.settingName)}</div>` : ''}
    <div style="text-align:center;font-size:${fontSize + 2}px;margin-bottom:3px;">退药单</div>
    ${row('姓名', [patient.userName, sex, age].filter(Boolean).join(' '))}
    ${row('手机', phone)}${row('诊号', patient.medicalSection)}${row('医生', patient.doctorName)}${row('诊断', patient.diagnosis)}
    ${sections}
    <div style="border-top:1px dashed #000;padding-top:${lineSpacing}px;">
      ${row('收费员', patient.chargeUserName)}${row('退药人', patient.withdrawalUserName)}
      ${patient.withdrawalTime ? row('退药时间', custFormatDate(patient.withdrawalTime, 'YYYY-MM-DD HH:mm:ss')) : ''}
      ${row('打印时间', custFormatDate(printedAt, 'YYYY-MM-DD HH:mm:ss'))}
      ${row('地址', patient.clinicAddress)}${row('电话', patient.contactPhone)}
    </div>
  </div>`
}